import { gql } from 'graphql-request';

import {
  SelectedMaterialDownloadUrlsClassName,
  SelectedMaterialDownloadUrlsID,
  SelectedMaterialDownloadUrlsType,
  SelectedMaterialDownloadUrlsUrl,
  SelectedMaterialDownloadUrlsUUID,
  SelectedMaterialID,
  SelectedMaterialUUID
} from '../selectedMaterialsTypes';

export interface FetchSelectedMaterialDownloadUrlsQueryResponse {
  id: SelectedMaterialID;
  uuid: SelectedMaterialUUID;
  downloadUrls: {
    url: SelectedMaterialDownloadUrlsUrl;
    id: SelectedMaterialDownloadUrlsID;
    uuid: SelectedMaterialDownloadUrlsUUID;
    type: SelectedMaterialDownloadUrlsType;
    className: SelectedMaterialDownloadUrlsClassName;
  }[];
}

export const FETCH_SELECTED_MATERIAL_DOWNLOAD_URLS_QUERY = gql`
  query SelectedMaterialDownloadUrls($uuid: ID!) {
    selectedMaterial(uuid: $uuid) {
      id
      uuid
      downloadUrls {
        className
        url
        id
        uuid
        type
      }
    }
  }
`;
